export enum MxInstitutionStatus {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
  UNBOUND = 'UNBOUND',
}
